import { render, staticRenderFns } from "./productTypeSelector.vue?vue&type=template&id=ac106ec8&scoped=true&"
import script from "./productTypeSelector.vue?vue&type=script&lang=js&"
export * from "./productTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./productTypeSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./productTypeSelector.vue?vue&type=style&index=1&id=ac106ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac106ec8",
  null
  
)

export default component.exports